/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ILoyaltyAutoEnrollViewProps } from './loyalty-auto-enroll';

export default (props: ILoyaltyAutoEnrollViewProps) => {
    return null;
};
